import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Paper, Grid, Stack, Button, Typography } from '@mui/material';
import { Add, ManageAccounts } from '@mui/icons-material';
import '../../App.css';
import Popup from '../Popup';
import Notification from '../Notification';
import UsersTable from '../table-data/UsersTable';
import UserForm from './UserForm';
import ResetPasswordForm from './ResetPasswordForm';

function ViewUsers() {
  const isAdmin = useSelector((state) => state.auth.activeUserRole) === 'ADMIN';
  const [popup, setPopup] = useState({ open: false, mode: 'add', user: null });
  const [reloadKey, setReloadKey] = useState(0);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });

  const openPopup = (mode, user = null) => setPopup({ open: true, mode, user });
  const setOpenPopup = (open) => setPopup((prev) => ({ ...prev, open }));

  const handleSuccess = (message, type = 'success') => {
    setOpenPopup(false);
    setReloadKey((prev) => prev + 1);
    if (message) setNotify({ isOpen: true, message, type });
  };

  const popupTitle = {
    add: 'Add User',
    edit: 'Edit User',
    reset: `Reset Password${popup.user ? ` - ${popup.user.username}` : ''}`,
  }[popup.mode];

  if (!isAdmin) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', margin: '40px' }}>
        <Typography variant="h6" color="error">
          Only company admins can access User Management.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', margin: '10px', padding: '30px' }}>
      <Paper elevation={0} sx={{ width: '1000px' }}>
        <Grid className="form-title" style={{ marginBottom: '-60px' }} container spacing={2}>
          <Grid item>
            <Typography variant="h5" sx={{ textAlign: 'center', margin: 5 }}>
              User Management
            </Typography>
          </Grid>
          <Grid item>
            <ManageAccounts sx={{ marginLeft: '-30px', width: 40, height: 40, color: '#344D67' }} />
          </Grid>
        </Grid>
        <Stack spacing={2} sx={{ margin: '30px' }}>
          <Stack display="flex" sx={{ alignItems: 'flex-end' }}>
            <Button
              style={{ width: '140px', marginBottom: '-10px', marginTop: '10px' }}
              className="form-btn"
              variant="outlined"
              color="success"
              onClick={() => openPopup('add')}
              startIcon={<Add sx={{ width: 24, height: 24 }} style={{ marginRight: '-8px' }} />}
              sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
            >
              Add User
            </Button>
          </Stack>

          <UsersTable
            reloadKey={reloadKey}
            onEdit={(user) => openPopup('edit', user)}
            onResetPassword={(user) => openPopup('reset', user)}
          />
        </Stack>

        <Popup title={popupTitle} openPopup={popup.open} setOpenPopup={setOpenPopup}>
          {popup.mode === 'reset' ? (
            <ResetPasswordForm user={popup.user} onSuccess={handleSuccess} />
          ) : (
            <UserForm initialData={popup.mode === 'edit' ? popup.user : null} onSuccess={handleSuccess} />
          )}
        </Popup>
      </Paper>
      <Notification notify={notify} setNotify={setNotify} />
    </Box>
  );
}

export default ViewUsers;
